import { GuidesPage } from "../../GuidesPage";
import { seoContent } from "../../../../constants/SEOConstant";
import { PairSyncGuideContent } from "../../PairSyncGuideContent";

export default function SyncSpotifyToTidal() {
    return (
        <GuidesPage
            seoData={seoContent.syncSpotifyToTidal}
            sections={<PairSyncGuideContent sourceKey="spotify" destKey="tidal" />}
        />
    );
}
